import React from 'react';
import { Star } from 'lucide-react';

const reviews = [
  { name: 'Gaia P.', text: "Incredibly patient and clear explanations. Passed first time!" },
  { name: 'Alfred D.', text: "Fantastic instructor, passed my test on my first attempt." },
  { name: 'Megan L.', text: "Switching to Ian made the difference — I passed!" },
  { name: 'Chris O.', text: "Informative, supportive, and patient. Passed first try!" },
  { name: 'Aidan M.', text: "Clear instructions and helpful tips. Highly recommend!" },
  { name: 'Simon M.', text: "Ian made learning to drive enjoyable. I passed!" },
];

const GoogleLogo = () => (
  <svg className="h-4 w-4 flex-shrink-0" viewBox="0 0 24 24" fill="none">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

const StarRating = () => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star key={i} className="h-3 w-3 fill-amber-400 text-amber-400" />
    ))}
  </div>
);

const ReviewItem = ({ review }: { review: typeof reviews[0] }) => (
  <div className="flex items-center gap-3 px-4 py-2 bg-white/15 rounded-full border border-white/25 whitespace-nowrap">
    <GoogleLogo />
    <StarRating />
    <span className="text-sm text-white/90">"{review.text}"</span>
    <span className="text-sm font-medium text-white">— {review.name}</span>
  </div>
);

const ScrollingReviewBar: React.FC = () => {
  // Duplicate reviews for seamless infinite scroll
  const duplicatedReviews = [...reviews, ...reviews];

  return (
    <div className="w-full overflow-hidden py-3 border-b border-white/10" style={{ background: 'linear-gradient(90deg, #0a1430 0%, #122046 50%, #0a1430 100%)' }}>
      <div className="flex items-center gap-6 animate-scroll">
        {duplicatedReviews.map((review, index) => (
          <ReviewItem key={index} review={review} />
        ))}
      </div>
      
      {/* CSS for infinite scroll animation */}
      <style>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 40s linear infinite;
          width: max-content;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default ScrollingReviewBar;
